import { FC, memo } from 'react'
import { Box } from '@chakra-ui/react'
import { createIcon } from '@chakra-ui/icons'

import { CustomIconProps } from 'types'
import CustomIcon from '../../CustomIcon'

const LettersOutline = createIcon({
  displayName: 'LettersOutline',
  viewBox: '0 0 24 24',
  path: (
    <>
      <g fill="none">
        <path d="M0 0h24v24h-24Z"></path>
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M7.432 5h12.211c.749 0 1.357.608 1.357 1.357v8.013c0 .75-.608 1.357-1.357 1.357h-12.211c-.749.001-1.357-.607-1.357-1.357v-8.013c0-.749.608-1.357 1.357-1.357Z"
        ></path>
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M6.175 5.93l6.185 4.424c.695.497 1.629.498 2.325.002l6.214-4.432"
        ></path>
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M16.568 19h-11.568c-1.105 0-2-.895-2-2v-7.369"
        ></path>
      </g>
    </>
  ),
})

const LettersTwoTone = createIcon({
  displayName: 'LettersTwoTone',
  viewBox: '0 0 24 24',
  path: (
    <>
      <Box as="g" fill="none">
        <path d="M0 0h24v24h-24Z"></path>
        <Box
          as="path"
          fill="twoToneLightColor"
          stroke="twoToneFillColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M7.432 5h12.211c.749 0 1.357.608 1.357 1.357v8.013c0 .75-.608 1.357-1.357 1.357h-12.211c-.749.001-1.357-.607-1.357-1.357v-8.013c0-.749.608-1.357 1.357-1.357Z"
        ></Box>
        <Box
          as="path"
          stroke="twoToneFillColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M6.175 5.93l6.185 4.424c.695.497 1.629.498 2.325.002l6.214-4.432"
        ></Box>
        <Box
          as="path"
          stroke="twoToneFillColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M16.568 19h-11.568c-1.105 0-2-.895-2-2v-7.369"
        ></Box>
      </Box>
    </>
  ),
})

const Letters: FC<CustomIconProps> = (props) => {
  if (props.variant === 'twoTone') return <CustomIcon as={LettersTwoTone} {...props} />
  return <CustomIcon as={LettersOutline} {...props} />
}

export default memo(Letters)
